import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import Select from "react-select";
import { useLocation } from "react-router";
import { usePermissions } from "../../common/PermissionContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const SubSubMenu = () => {

    const [subSubMenuList, setSubSubMenuList] = useState<any[]>([]);
    const [subMenuList, setSubMenuList] = useState<any[]>([]);
    const [accountTypeList, setAccountTypeList] = useState<any[]>([]);
    const [accountTypeId, setAccountTypeId] = useState("");
    const [submenuId, setSubMenuId] = useState("");
    const [childSubMenuId, setChildSubMenuId] = useState("");
    const [title, setTitle] = useState("");
    const [hasAccess, setHasAccess] = useState("");
    const [hasSubMenuAccess, setHasSubMenuAccess] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [childSubMenuOrder, setChildSubMenuOrder] = useState("");
    const [childSubMenuRoute, setChildSubMenuRoute] = useState("");
    const [childSubMenuStatus, setChildSubMenuStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchChildSubMenus();
    }, [])

        async function fetchChildSubMenus() {
            setIsLoading(true);
            const sbmnuResponse = await func.getChildSubMenus(null);
            setSubSubMenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
            setIsLoading(false);
        }
        
    const filteredData = subSubMenuList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const submenuRender = (rowData) => {
        return <span>{rowData.submenuTitle}</span>;
    };

    const childSubMenuNameRender = (rowData) => {
        return <span>{rowData.title}</span>;
    };

    const childsubMenuOrderRender = (rowData) => {
        return <span>{rowData.subSubmenuOrder}</span>;
    };

    const childsubMenuRouteRender = (rowData) => {
        return <span>{rowData.subSubmenuRoute}</span>;
    };

    const childsubMenuStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSubMenu(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const sbmnuId = rowData.subSubMenuId;

        return (
            <Link to="#" onClick={() => deleteChildSubMenu(sbmnuId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newChildSubMenu() {
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        setIsEdit(false)
        setOpenModal(true)
        setTitle("");
        setSubMenuId("");
        setChildSubMenuId("");
        setAccountTypeId("");
        setHasAccess("");
        setChildSubMenuRoute("");
        setChildSubMenuOrder("");
    }

    async function editSubMenu(rowData) {
        const chldmnuId = rowData.subSubMenuId;
        setIsEdit(true)
        setOpenModal(true)
        const sbmnuResponse = await func.listSubMenus();
        setSubMenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        const getDetails = await func.getChildSubMenus(chldmnuId);
        if (getDetails) {
            setAccountTypeId(getDetails.accountAccess);
            setChildSubMenuId(getDetails.subSubMenuId);
            setSubMenuId(getDetails.subMenuId);
            setTitle(getDetails.title);
            setChildSubMenuRoute(getDetails.subSubmenuRoute);
            setChildSubMenuOrder(getDetails.subSubmenuOrder);
            setHasAccess(getDetails.hasSubSubmenuAccess);
            setChildSubMenuStatus(getDetails.status);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateChildSubMenu();
            } else {
                const formData = new FormData();
                formData.append("subMenuId", submenuId);
                formData.append("title", title);
                formData.append("subSubmenuRoute", childSubMenuRoute);
                formData.append("subSubmenuOrder", childSubMenuOrder);
                formData.append("hasSubSubmenuAccess", hasAccess);
                formData.append("accountAccess", accountTypeId);

                const createSubMenu = api.ChildSubMenu;
                fetch(createSubMenu, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Created',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchChildSubMenus();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }
    function updateChildSubMenu() {
        const formData = new FormData();
        formData.append("subMenuId", submenuId);
        formData.append("title", title);
        formData.append("subSubmenuRoute", childSubMenuRoute);
        formData.append("subSubmenuOrder", childSubMenuOrder);
        formData.append("hasSubSubmenuAccess", hasAccess);
        formData.append("accountAccess", accountTypeId);
        formData.append("status", childSubMenuStatus);

        const updateChildSubMenu = api.ChildSubMenu + '/' + childSubMenuId;
        fetch(updateChildSubMenu, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchChildSubMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteChildSubMenu(sbmnuId: string) {
        const deletemnu = api.ChildSubMenu + '/' + sbmnuId + '/' + 0;
        fetch(deletemnu, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchChildSubMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>

            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Child Sub Menus</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newChildSubMenu() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Sub Menu">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuTitle"
                                                header="Sub Menu Name"
                                                body={submenuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="title"
                                                header="Child Sub Menu"
                                                body={childSubMenuNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="subSubmenuRoute"
                                                header="Child Sub Menu Route"
                                                body={childsubMenuRouteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="subSubmenuOrder"
                                                header="Child Sub Menu Order"
                                                body={childsubMenuOrderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={childsubMenuStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* {currentPermissions.includes("edit") ? */}
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                {/* : null
                                            }
                                            {currentPermissions.includes("delete") ? */}
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                {/* : null
                                            } */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Child Sub Menu</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Account Access</label>
                                    <Select
                                        value={accountTypeList.find(acc => acc.accountTypeId === accountTypeId) ? {
                                            value: accountTypeId,
                                            label: accountTypeList.find(acc => acc.accountTypeId === accountTypeId)?.accountName
                                        } : null}
                                        onChange={async (e) => {
                                            setAccountTypeId(e.value);
                                            const sbmnuResponse = await func.listSubMenus();
                                            setSubMenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
                                        }}
                                        required
                                        // styles={customSelect}
                                        placeholder="Select Account Type"
                                        options={accountTypeList.map(acc => ({
                                            value: acc.accountTypeId,
                                            label: acc.accountName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Sub Menu</h6></label>
                                    <Select
                                        value={subMenuList.find(sbmnu => sbmnu.submenuId === submenuId) ? {
                                            value: submenuId,
                                            label: subMenuList.find(sbmnu => sbmnu.submenuId === submenuId).submenuTitle
                                        } : null}
                                        onChange={(e) => {
                                            setSubMenuId(e.value);
                                        }}
                                        required
                                        placeholder="Select Menu"
                                        options={subMenuList.map(menu => ({
                                            value: menu.submenuId,
                                            label: menu.submenuTitle
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Child Sub Menu Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Child Sub Menu Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Child Sub Menu Route</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="childSubMenuRoute"
                                            value={childSubMenuRoute}
                                            onChange={(e) => setChildSubMenuRoute(e.target.value)}
                                            placeholder="Child Sub Menu Route" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Child Sub Menu Order</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="childSubMenuOrder"
                                            value={childSubMenuOrder}
                                            onChange={(e) => setChildSubMenuOrder(e.target.value)}
                                            placeholder="Child Sub Menu Order" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="row">
                                        <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Has Sub Menu Access</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    required
                                                    checked={hasAccess === '1'}
                                                    id="hasAccess"
                                                    onChange={(e) => {
                                                        setHasAccess(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={childSubMenuStatus === '1'}
                                                        id="childSubMenuStatus"
                                                        onChange={(e) => {
                                                            setChildSubMenuStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
}

export default SubSubMenu;